import React from 'react'
import { Container, Tabs, Tab } from 'react-bootstrap'
import './style.css'

export default function Main() {

    let notivMalmora = MalmoraNotiv.length
    let notivBerberkah = Berberkah.length

    return (
        <>
        <Container className="judul-notifkasi-page"><h3>Notifikasi ({notivMalmora + notivBerberkah})</h3></Container>
        <Container className="notifkasi-page">
            <Tabs>
                <Tab eventKey="molomora" title={`Malmora(${notivMalmora})`}>
                    {
                        MalmoraNotiv.map((name, key) => {
                            return (
                                <div key={key} className="malmora-notification">
                                    <img src="asset/notiv/notiv.png" alt="notiv" />
                                    <div className="content">
                                        <h5>{name.title}</h5>
                                        <p>{name.text}</p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </Tab>
                <Tab eventKey="berberkah" title={`Berberkah(${notivBerberkah})`}>
                {
                    Berberkah.map((name, key) => {
                        return (
                            <div key={key} className="malmora-notification">
                                <img src="asset/notiv/notiv.png" alt="notiv" />
                                <div className="content">
                                    <h5>{name.title}</h5>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et neque elit turpis mus laoreet sed consequat. Quam sagittis condimentum ultrices commodo ultricies et enim tempus cras. Nam senectus congue egestas sed vitae et non non nunc. Pulvinar nibh sem phasellus pulvinar ac curabitur velit. Varius duis odio donec suspendisse sem sollicitudin velit. Congue habitant dictumst sodales elit tortor dignissim.</p>
                                </div>
                            </div>
                        )
                    })
                }
                </Tab>
            </Tabs>
        </Container>
        </>
    )
}

let MalmoraNotiv = [
    {title:"Ramadhan Berkah Dengan Sedekah !", text:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et neque elit turpis mus laoreet sed consequat. Quam sagittis condimentum ultrices commodo ultricies et enim tempus cras. Nam senectus congue egestas sed vitae et non non nunc. Pulvinar nibh sem phasellus pulvinar ac curabitur velit. Varius duis odio donec suspendisse sem sollicitudin velit. Congue habitant dictumst sodales elit tortor dignissim."},
    {title:"Ramadhan Berkah Dengan Sedekah !", text:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et neque elit turpis mus laoreet sed consequat. Quam sagittis condimentum ultrices commodo ultricies et enim tempus cras. Nam senectus congue egestas sed vitae et non non nunc. Pulvinar nibh sem phasellus pulvinar ac curabitur velit. Varius duis odio donec suspendisse sem sollicitudin velit. Congue habitant dictumst sodales elit tortor dignissim."},
    {title:"Ramadhan Berkah Dengan Sedekah !", text:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et neque elit turpis mus laoreet sed consequat. Quam sagittis condimentum ultrices commodo ultricies et enim tempus cras. Nam senectus congue egestas sed vitae et non non nunc. Pulvinar nibh sem phasellus pulvinar ac curabitur velit. Varius duis odio donec suspendisse sem sollicitudin velit. Congue habitant dictumst sodales elit tortor dignissim."}
]

let Berberkah = [
    {title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"},{title:"Ramadhan Berkah Dengan Sedekah !"}
]


